<template>
  <section class="section-container">
    <v-row class="sign_in">
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="12"
        md="6"
        class="left"
      >
        <v-img
          height="75%"
          max-width="1000"
          :src="require(`@/assets/images/driver_login.png`)"
          style="top: 8%"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="right"
        :class="$vuetify.breakpoint.smAndDown ? 'background-image' : ''"
      >
        <div style="position: relative;width: 100%;top: 15%;">
          <div style="position: absolute;width: 100%;">
            <v-layout justify-center>
              <v-img
                max-height="300"
                max-width="300"
                contain
                :src="require(`@/assets/images/DXEstation_logo_RGB.png`)"
              />
            </v-layout>
            <h1>Login</h1>
            <validation-observer ref="observer">
              <v-form @submit.prevent="loginButtonClickEvent">
                <v-row>
                  <v-col cols="12" md="10" offset-md="1">
                    <v-card class="rounded-card" style="padding: 20px">
                      <v-card-title></v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="ログインID"
                              rules="required"
                            >
                              <v-text-field
                                v-model="loginId"
                                :error-messages="errors"
                                name="loginId"
                                outlined
                                persistent-placeholder
                                autocomplete="off"
                              >
                                <template v-slot:label>
                                  <v-icon small>
                                    mdi-account-outline
                                  </v-icon>&nbsp;ログインID
                                </template>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ errors }"
                              name="パスワード"
                              rules="required"
                            >
                              <v-text-field
                                v-model="password"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :error-messages="errors"
                                :type="showPassword ? 'text' : 'password'"
                                name="password"
                                outlined
                                persistent-placeholder
                                autocomplete="off"
                                @click:append="showPassword = !showPassword"
                              >
                                <template v-slot:label>
                                  <v-icon small>
                                    mdi-lock-outline
                                  </v-icon>&nbsp;パスワード
                                </template>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          type="submit"
                          color="primary"
                          block
                          large
                          elevation="4"
                        >
                          ログイン
                        </v-btn>
                      </v-card-actions>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          text
                          x-large
                          @click="remindButtonClickEvent"
                        >
                          パスワードをお忘れですか？
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
          </div>
        </div>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'DriverSessionIndex',
  components: {
  },
  mixins: [
  ],
  data () {
    return {
      loginId: null,
      password: null,
      showPassword: false,
    }
  },
  created() {
    this.signOut()
  },
  methods: {
    ...mapActions('DriverAuthentication', {
      signIn: 'signInDriver',
      signOut: 'signOutDriver'
    }),
    ...mapActions("DriverAppVariable", {
      resetMenuKey: "resetState",
      saveMenuKey: "saveMenuKey"
    }),
    loginButtonClickEvent () {
      const params = {
        login_id: this.loginId,
        password: this.password,
      }
      const backURL = this.$route.query.backuri;
      this.resetMenuKey()
      this.signIn({params: params}).then((content) => {
        let user = content.user
        let jw_mode = content.jw_mode

        if (jw_mode) {
          this.saveMenuKey({ menuKey: "5_1" })
        }

        /**
         * @typedef user { Object }
         * @property use_initial_password { Boolean }
         */
        if (user.use_initial_password || user.needs_changing_password) {
          this.$router.replace({name: 'DriverInitialPasswordEdit'}, () => {})
        } else {
          if (jw_mode) {
            const route = 'backuri' in this.$route.query && this.$route.query.backuri.match(/^\//) ? {path: this.$route.query.backuri} : { name: "DriverManifestManagements", params: { resetCondition: true }}
            this.$router.push(route, () => {})
          } else {
            this.$router.push({path: backURL && backURL.match(/^\//) ? backURL : '/driver/home'}, () => {})
          }
        }
      }).finally(() => {

      })
    },
    remindButtonClickEvent () {
      this.$router.replace({ name: 'DriverForget' }, () => {})
    },
  }

}
</script>

<style scoped lang="scss">

.background-image {
  background-image: linear-gradient(to right top, #2d61aa, #1b77b9, #118cc6, #23a1cf, #3fb5d7);
  background-size: cover;
}
.section-container {
  background: #fafafa;
  .sign_in {
    .left {
      background-image: linear-gradient(to right top, #2d61aa, #1b77b9, #118cc6, #23a1cf, #3fb5d7);
      & .v-img {

      }
    }
    height: 93vh;
    .right {
      h1 {
        color: #000000;
        text-align: center;
        margin: 10px 40px 40px 40px;
      }
    }
  }
}

</style>

